@if (workspace(); as workspace) {
  <section aria-label="Item access" class="p-8">
    <p class="font-medium">Your effective access: {{ permission() }}</p>
    <p>
      {{ workspace === 'team' ? teamManager() ? 'Team admins can manage every item in this workspace.' : 'Team membership grants edit access.' : 'The private owner can manage this item.' }}
    </p>
    <table class="mt-6 w-full text-left text-sm">
      <thead>
        <tr>
          <th scope="col">Person / audience</th>
          <th scope="col">Source</th>
          <th scope="col">Permission</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ workspace === 'team' ? identity()?.spaceTitle + ' members' : 'You' }}</td>
          <td>{{ workspace === 'team' ? 'Team membership' : 'Private owner' }}</td>
          <td>{{ workspace === 'team' ? 'Edit content' : 'Manage' }}</td>
        </tr>
      </tbody>
    </table>
  </section>
}
